import React from 'react'
import "./Home.css"
import { Hero, Destinations, Services, Packages, Booking, Subscribe } from '../../Features/Home'

const Home = ({ pageData, url }) => {
  return (
    <div>
        <Hero 
          pageData={pageData}
          url={url} 
        />
        <Destinations 
          pageData={pageData}
          url={url}
        />
        <Services
          pageData={pageData}
          url={url}
        />
        <Packages 
          pageData={pageData}
          url={url}
        />
        <Booking 
          pageData={pageData}
          url={url}
        />
        <Subscribe
          pageData={pageData}
          url={url}
        />
    </div>
  )
}

export default Home